const RemoveEmptyKey = (obj) => {
        if (typeof obj !== 'object' || obj === null) {
                return obj;
        }

        if (Array.isArray(obj)) {
                const filteredArray = obj
                        .map(RemoveEmptyKey)
                        .filter((value) => value !== null && value !== undefined);

                return filteredArray.length > 0 ? filteredArray : null;
        }

        const filteredObj = {};
        for (const key in obj) {
                const value = RemoveEmptyKey(obj[key]);
                if (value !== null && value !== undefined && value !== '') {
                        if (
                                typeof value === 'object' &&
                                !Array.isArray(value) &&
                                Object.keys(value).length === 0
                        ) {
                                continue;
                        }
                        filteredObj[key] = value;
                }
        }

        return Object.keys(filteredObj).length > 0 ? filteredObj : null;
};

export { RemoveEmptyKey };
